import React, { FC, MutableRefObject, useEffect, useRef } from 'react';
import { Container }                                      from 'semantic-ui-react';
import { QueryResult }                                    from '@apollo/react-common';

import { SemanticUISize, Size, Uuid }        from '../../../../../types';
import { useCurrentUser, useSystemSidebar, } from '../../../../../hooks';
import { Page, PageMeta }                    from '../../../../containers';
import { CorvalStylizedHexContainer }        from '../../../../components/product/CorvalStylizedHexContainer';
import { ProjectsByOrganizationList }        from './ProjectsByOrganizationList';
import { IntercomIdentifier }                from '../../../../components/util/external/IntercomIdentifier';


interface ProjectDashboardContextType {
    projectListRequestRef: MutableRefObject<QueryResult>,
    getVisibleOrgIds: MutableRefObject<() => Uuid[]>,
}

export const ProjectDashboardContext = React.createContext<ProjectDashboardContextType>( null )

const ProjectDashboardIndexPage: FC = () => {

    let { currentUser }       = useCurrentUser(),
        projectListRequestRef = useRef<QueryResult>(),
        getVisibleOrgIds      = useRef<() => Uuid[]>(),
        contextRef            = useRef<ProjectDashboardContextType>( { projectListRequestRef, getVisibleOrgIds } );

    const systemSidebarActions = useSystemSidebar();

    useEffect( () => {
        // clearing out any content that are project dependent.
        systemSidebarActions.setContent( null );

    }, [] )

    useEffect( () => {

        contextRef.current = {
            ...contextRef.current,
            projectListRequestRef
        }

    }, [ projectListRequestRef ] )

    return (

        <Page name={ 'app-projects-dashboard' } ignoreDisplaySettings={ true } showToggleMode={ false } showNav={ false }>

            <PageMeta title={ 'Project Dashboard' }>

                <CorvalStylizedHexContainer
                    fill={ 'area' }
                    size={ SemanticUISize.MINI }
                    fadeDirection={ 'down' }
                    padding={ [ Size.LG, Size.MD ] }>

                    <ProjectDashboardContext.Provider value={ contextRef.current }>

                        <Container>

                            {/* PROJECT BY ORG LIST */ }
                            { currentUser && <ProjectsByOrganizationList/> }

                        </Container>

                    </ProjectDashboardContext.Provider>

                </CorvalStylizedHexContainer>

            </PageMeta>

            <IntercomIdentifier/>

        </Page>

    )
}

export default ProjectDashboardIndexPage;
